





















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AdminFraudmindAttentionRequired extends Vue {
  // Props
  @Prop({ default: () => [] })
  public clientsQuickFilters!: any[];

  @Prop({ default: () => [] })
  public ordersQuickFilters!: any[];

  @Prop({ default: () => [] })
  public invoicesQuickFilters!: any[];
}
